import LookUpModel from "./LookUpModel";

export default class FonteModel extends LookUpModel {
    public readonly sourceDetail: LookUpModel[] = [];

    constructor(data: Partial<FonteModel>) {
        super(data);

        this.update(data);
    }
}
